import React, {ReactElement, useEffect, useState} from 'react';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  DialogTitle,
  Divider,
  Select,
  Typography,
  MenuItem,
  ListItemText,
  Radio
} from '@material-ui/core';
import moment from 'moment';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {useSnackbar} from 'notistack';
import {useSelector} from 'react-redux';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {Trans, useTranslation} from 'react-i18next';

import {SnackBarConfig} from 'src/utils/SnackBarConfig';

import {getAllCustomTemplates} from '@shared/services/CustomMessageServices';

import './CopayCancelAlert.scss';
import {
  APP,
  APP_PRIMARY_COLOR,
  BUTTON_DISABLE_COLOR,
  DEFAULT_BLACK_COLOR,
  DEFAULT_GREY_COLOR,
  DEFAULT_WHITE_COLOR
} from 'src/style/variable';
import CustomSelectField from '../ClinicGroups/AddUser/CustomSelectField';
import CheckBoxField from '@components/system/CheckBox/CheckBoxField';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import {checkPaymentPlanExist} from '@shared/services/ClinicServices';
import {SendCustomMessageTypes} from '@shared/constants/Mapping';
import NotificationToGuarantorDialog from './NotificationToGuarantorDialog';

const AlertStyles = makeStyles(() => ({
  root: {
    '&:MuiDialog-paperWidthSm': {
      width: '20rem'
    },
    '&:.MuiDialog-paperFullWidth': {
      width: '20rem'
    }
  },

  dateRangeLabel: {
    margin: '1rem 0'
  },
  filterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  menu: {
    maxHeight: '20rem',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflowWrap: 'break-word'
    }
  },

  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflowWrap: 'break-word'
    }
  },

  dropDownWidth: {
    minWidth: '15rem'
  },
  text: {
    fontSize: '1.3rem'
  },
  deleteClinicButton: {
    height: '3rem',
    width: '5rem',
    color: DEFAULT_WHITE_COLOR,
    borderRadius: '4pt',
    fontSize: '1.2rem',
    textTransform: 'capitalize',
    backgroundColor: APP_PRIMARY_COLOR,
    '&:hover': {
      backgroundColor: APP_PRIMARY_COLOR
    }
  },
  cancelButton: {
    height: '3rem',
    width: '5rem',
    color: DEFAULT_BLACK_COLOR,
    borderRadius: '4pt',
    fontSize: '1.2rem',
    textTransform: 'capitalize'
  },
  disableButton: {
    height: '3rem',
    width: '5rem',
    color: DEFAULT_GREY_COLOR,
    borderRadius: '4pt',
    fontSize: '1.2rem',
    textTransform: 'capitalize',
    backgroundColor: BUTTON_DISABLE_COLOR,
    '&:hover': {
      backgroundColor: BUTTON_DISABLE_COLOR
    }
  },
  ClinicFilterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  clinicText: {
    fontSize: '1.3rem'
  },
  clearAll: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  ClinicMenu: {
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  renderAllInvoicesButtonsAddOn: {
    whiteSpace: 'nowrap',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    marginRight: '1.2rem',
    marginTop: '1rem',
    marginBottom: '0.5rem'
  },
  checkBox: {
    paddingLeft: '0.5rem',
    lineHeight: '1.1rem'
  }
}));

const textArea = {
  height: 100,
  width: '100%',
  marginBottom: '0rem',
  marginTop: '0.5rem',
  borderColor: '#c1c1c1',
  borderRadius: '3pt',
  paddingTop: '1rem',
  paddingLeft: '0.8rem',
  opacity: 0.6,
  fontFamily: APP.FONT_FAMILY.REGULAR,
  fontSize: '1rem',
  overflow: 'auto'
};
// FIXME: ADD INTERFACE FOR THE PROPS
const CustomMessageDialog = (props: any): ReactElement => {
  const {t} = useTranslation();
  const classes = AlertStyles();
  const {enqueueSnackbar} = useSnackbar();

  const {
    open,
    title,
    subtitle,
    handleCancel,
    // handleOpen,
    sendNotification,
    reminderType,
    setSendStatementsPaymentPlan,
    type,
    confirmDialogTitle,
    confirmDialogSubTitle,
    fromDate,
    toDate,
    currentGroup,
    // setAppointmentDateRangeFilterDialog,
    // openCustomMessageDialog,
    setOpenCustomMessageDialog
  } = props;

  const [message, setMessage] = useState<string>('');
  const [selectedTemplate, setSelectedTemplate]: any = useState({});

  const [templateList, setTemplateList]: any = useState([]);

  const acOfClinics: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );
  const acOfClinicLabels: any = useSelector(
    (state: any) => state.clinics.selectedClinicLabel || []
  );

  const groupId: any = useSelector((state: any) => state.auth.groupId);

  const [check, setCheck]: any = useState(false);

  const [openDialogBox, setOpenDialogBox] = useState(false);

  const [paymentPlanDialog, setPaymentPlanDialog] = useState<boolean>(false);
  const [
    openSendNotificationDialogBox,
    setOpenSendNotificationDialogBox
  ] = useState<boolean>(false);

  const handleClose = () => {
    if (typeof handleCancel === 'function') {
      handleCancel();
    }
  };

  // const handleOpenMessageDialog = () => {
  //   if (typeof handleOpen === 'function') {
  //     handleOpen();
  //   }
  // };

  const getCustomTemplates = async (): Promise<void> => {
    try {
      const response = await getAllCustomTemplates(
        groupId,
        Array.isArray(acOfClinics) ? acOfClinics[0] : ''
      );
      if (response?.data?.length > 0) {
        setTemplateList(response?.data);
      }
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
    }
  };

  useEffect(() => {
    if (groupId && acOfClinics[0]) {
      getCustomTemplates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, acOfClinics[0]]);

  const handleTemplateSelection = (template: any) => {
    setMessage(template?.parsed_template);
    setSelectedTemplate(template);
  };

  const clearTemplate = () => {
    setMessage('');
    setSelectedTemplate({});
  };

  const handleCustomMessage = (event: any) => {
    setMessage(event?.target.value);
  };

  const handleIncludeSalutationCheckBox = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  };

  const handleConfirm = (sendNotificationToGuarantor: boolean) => {
    if (typeof sendNotification === 'function') {
      sendNotification(check, message, sendNotificationToGuarantor);
    }
  };

  const renderBody = () => {
    return (
      <div className={classes.menu}>
        {fromDate !== null &&
          fromDate !== undefined &&
          toDate !== null &&
          toDate !== undefined && (
            <div className={classes.dateRangeLabel}>
              {t('DUE_INVOICES.DATE_RANGE')}
              <b>
                {moment(fromDate).format('MM/DD/YYYY')} -{' '}
                {moment(toDate).format('MM/DD/YYYY')}
              </b>
            </div>
          )}
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={
            selectedTemplate?.name_id
              ? selectedTemplate?.name_id
              : t('DUE_INVOICES.CUSTOM_MESSAGES.SELECT_TEMPLATE')
          }
          variant="outlined"
          fullWidth={true}
          style={message ? {} : {opacity: 0.5}}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView select-clinic"
          data-test-id="pcl-appointments-selectTemplate">
          <div className={classes.root}>
            <div className={classes.ClinicFilterHeader}>
              <Typography className={classes.clinicText}>
                {t('DUE_INVOICES.CUSTOM_MESSAGES.SELECT_TEMPLATE')}
              </Typography>
              <Button
                className={classes.clearAll}
                onClick={() => clearTemplate()}>
                {t('COMMON.CLEAR_ALL')}
              </Button>
            </div>
            <Divider />
            <div className={classes.ClinicMenu}>
              {templateList.map((template: any, index: number) => {
                return (
                  <MenuItem
                    key={template.id}
                    data-test-id={`pcl-appointments-customMessage${index}`}
                    value={template.name_id}
                    onClick={(): any => handleTemplateSelection(template)}>
                    <ListItemText
                      className={[classes.secondary, classes.primary].join(' ')}
                      primary={template.name_id}
                    />
                    <Radio checked={selectedTemplate?.id === template?.id} />
                  </MenuItem>
                );
              })}
            </div>
          </div>
        </Select>

        <div
          style={{display: 'none'}}
          className={classes.renderAllInvoicesButtonsAddOn}>
          <CheckBoxField
            onChange={(event: any) => handleIncludeSalutationCheckBox(event)}
            checked={check}
          />
          <span className={classes.checkBox}>
            {t('DUE_INVOICES.CUSTOM_MESSAGES.CHECK_BOX_TEXT')}
          </span>
        </div>

        <TextareaAutosize
          rowsMax={10}
          aria-label="maximum height"
          placeholder={t('DUE_INVOICES.CUSTOM_MESSAGES.TEXT_PLACEHOLDER')}
          defaultValue={message}
          value={message}
          onChange={(event: any) => handleCustomMessage(event)}
          style={{...textArea}}
          data-test-id="pcl-appointment-textarea"
        />
      </div>
    );
  };

  const checkPaymentPlanExistForConfig = async () => {
    if (type && type === SendCustomMessageTypes.STATEMENT) {
      const clinicPaymentPlan = await checkPaymentPlanExist({
        clinic_id: acOfClinics[0],
        group_id: groupId
      });

      if (
        clinicPaymentPlan &&
        clinicPaymentPlan?.data &&
        clinicPaymentPlan?.data?.is_enable
      ) {
        setPaymentPlanDialog(true);
      } else {
        setOpenDialogBox(true);
      }
    } else {
      setOpenDialogBox(true);
    }
    // setPaymentPlanDialog(false);
  };

  return (
    <div>
      <Dialog
        open={open && !openDialogBox && !openSendNotificationDialogBox}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        fullWidth={true}
        maxWidth={'sm'}
        className={classes.root}>
        <DialogTitle disableTypography>
          {title}
          <div className="sub">{subtitle}</div>
        </DialogTitle>
        <Divider />
        <DialogContent>{renderBody()}</DialogContent>
        <Divider />
        <DialogActions style={{display: 'flex'}}>
          <Button
            className={classes.cancelButton}
            onClick={() => handleClose()}
            data-test-id="pcl-appointments-cancel">
            {t('DUE_INVOICES.NOTIFICATION_DIALOG.BUTTON_CANCEL')}
          </Button>
          <Button
            className={
              message ? classes.deleteClinicButton : classes.disableButton
            }
            disabled={!message}
            onClick={() => {
              checkPaymentPlanExistForConfig();
            }}
            data-test-id="pcl-appointments-next">
            {t('DUE_INVOICES.CUSTOM_MESSAGES.NEXT')}
          </Button>
        </DialogActions>
      </Dialog>

      {openDialogBox && (
        <ConfirmationDialog
          open={openDialogBox}
          onClose={response => {
            if (response === 'confirm') {
              if (type === SendCustomMessageTypes.STATEMENT) {
                if (!currentGroup?.send_frequent_notification_guarantor) {
                  setOpenSendNotificationDialogBox(true);
                } else {
                  handleConfirm(true);
                }
              } else {
                setOpenDialogBox(false);
                // setAppointmentDateRangeFilterDialog(false);
                handleConfirm(true);
              }
            } else {
              setOpenDialogBox(false);
              // set the payment plan dialog to false when the confirmation dialog is closed
              setPaymentPlanDialog(false);
              setOpenCustomMessageDialog(true);
              // handleOpenMessageDialog();
            }
          }}
          title={
            <Trans
              i18nKey={confirmDialogTitle}
              values={{
                label: reminderType
              }}
              components={[<strong key={'X'} />]}
            />
          }
          description={
            <Trans
              i18nKey={confirmDialogSubTitle}
              values={{
                clinic: acOfClinicLabels[0]
              }}
              components={[<strong key={'X'} />]}
            />
          }
        />
      )}

      {openSendNotificationDialogBox && (
        <NotificationToGuarantorDialog
          open={openSendNotificationDialogBox}
          onClose={response => {
            if (response === 'yes') {
              handleConfirm(true);
            } else if (response === 'no') {
              handleConfirm(false);
            } else {
              // Close current dialog box
              setOpenSendNotificationDialogBox(false);
              // Open custom message dialog
              setOpenCustomMessageDialog(true);
              // handleOpenMessageDialog();
            }
          }}
          cancelButtonText={t('DUE_INVOICES.NO')}
          confirmButtonText={t('DUE_INVOICES.YES')}
          title={t('DUE_INVOICES.SEND_NOTIFICATION_GUARANTOR_TITLE')}
          description={
            <Trans
              i18nKey={'DUE_INVOICES.SEND_NOTIFICATION_GUARANTOR_DESCRIPTION'}
              values={{
                interval:
                  currentGroup?.notification_to_guarantor?.interval_time,
                interval_unit:
                  currentGroup?.notification_to_guarantor?.interval_time_unit
              }}
              components={[<strong key={'X'} />]}
            />
          }
        />
      )}

      {paymentPlanDialog && (
        <ConfirmationDialog
          open={paymentPlanDialog}
          title={t('PAYMENT_PLANS.PAYMENT_PLAN_CONFIRMATION_DIALOG_TITLE')}
          description={''}
          confirmButtonText={t('PAYMENT_PLANS.NO')}
          cancelButtonText={t('PAYMENT_PLANS.YES')}
          onClose={response => {
            if (response === 'confirm') {
              setSendStatementsPaymentPlan(false);
            } else {
              setSendStatementsPaymentPlan(true);
            }
            setOpenDialogBox(true);
          }}
        />
      )}
    </div>
  );
};

export default CustomMessageDialog;
